<template>
  <div style="margin-top: 5px;">
    <div v-if="msg.control_type === 'scorecard'">
        <div v-if="msg.scorecard_data != null" class="scorecard_box">
            <h1 class="is-size-1" style="padding-left: 20px; color: yellow;">
                <span v-if="msg.title != ''">
                    {{ msg.title }}
                </span>
                <span v-else>
                    (no title)
                </span>
            </h1>
            <GameSummary ref="gameSummary" v-bind:gameData="msg.scorecard_data.data"/> 
        </div>
        <div v-else>
            loading...
        </div>
    </div>
    <div v-else-if="msg.control_type === 'match'">
        <div class="box match_box">
            <h1 class="is-size-6 arcade-heading" style="padding-bottom: 8px; text-align: left;">
                {{ msg.title.replace("Completed","") }}
                <span v-if="msg.control_value.match.id.toString().indexOf('Finals') != -1"> (Finals)</span>
                <span v-if="msg.control_value.match.type != ''">{{  msg.control_value.match.type }}</span>
            </h1>
            <div v-for="(matchPlayer, index) in msg.control_value.match.matchPlayers" :key="index">
                <div class="columns is-mobile is-size-6" style="color: goldenrod;">
                    <div class="column is-5">
                        {{ matchPlayer.player.name }}
                    </div>
                    <div class="column is-5">
                        <div v-for="(axethrow, index) in matchPlayer.throws" :key="index" style="display: inline; float: left;">
                            <div
                                :class="axethrow.basicScore === 5 ? 'game-summary-throw-bullseye' : 'game-summary-throw'">
                                <span class="is-size-6">{{ axethrow.basicScore }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="column is-2" style="padding-left: 0px; padding-right: 0px;">
                        <span class="is-size-6">
                            {{ $parent.$parent.calculateTotalThrowsMatch(matchPlayer.throws) }}
                            <i v-if="matchPlayer.winner" class="fas fa-award winner" style="font-size: 0.7em;"></i>
                            <span v-if="matchPlayer.bye"><sup>(bye)</sup></span>
                        </span>
                    </div>
                </div>            
            </div>
            <!-- Mini target with hit positions -->
            <div class="mini-target-row">
                <div v-for="(matchPlayer, pIdx) in msg.control_value.match.matchPlayers" :key="'target-'+pIdx" class="mini-target-player">
                    <div class="mini-target-label" :style="{ color: getPlayerColor(pIdx) }">{{ matchPlayer.player.given_name || matchPlayer.player.name }}</div>
                    <div class="mini-target-container">
                        <img :src="`${publicPath}img/Target.png`" class="mini-target-img">
                        <i v-for="(hit, hIdx) in getScoredThrows(matchPlayer)" :key="'hit-'+hIdx"
                            class="fas fa-xmark mini-hit-marker"
                            :style="getHitStyle(hit, pIdx)">
                        </i>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else-if="msg.control_type === 'rankings'">
        <div class="box rankings">
            <h1 class="is-size-5 arcade-heading">Rankings</h1>
            <div class="columns is-mobile is-size-7" style="margin-bottom: 0px;">
                <div class="column is-6">
                    <u>Player</u>
                </div>
                <div class="column is-2">
                    <u>Avg</u>
                </div>
                <div class="column is-2">
                    <u>Total</u>
                </div>
                <div class="column is-2">
                    <u>Bulls</u>
                </div>
            </div>
            <div v-for="(player, index) in msg.control_value.playersSortedByAverage" :player="player" :key="player.player">
                <div class="columns is-mobile is-size-6" style="color: goldenrod;">
                    <div class="column is-1">
                        {{ (index+1) }}
                    </div>
                    <div class="column is-5">
                        {{ player.given_name || player.name}} 
                    </div>
                    <div class="column is-2">
                        <span>{{ player.average }}</span>
                    </div>
                    <div class="column is-2">
                        <span>{{ player.total }}</span>
                    </div>
                    <div class="column is-2">
                        <span>{{ player.bullseyes }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else-if="msg.control_type === 'new_game'">
        <div class="box rankings">
            <h1 class="is-size-6 arcade-heading">New Game</h1>
            <div v-for="(player, index) in msg.control_value.players" :key="index" style="color: goldenrod;">
                <div class="is-size-6">{{ player.name }}</div>
            </div>
        </div>
    </div>
    <div v-else-if="msg.control_type === 'game_completed'">
        <div class="box rankings">
            <div class="is-size-6">{{ msg.control_value.message }}</div>
        </div>
    </div>
    <div v-else>
        <span>{{ msg.control_type }} {{ msg.control_value }} {{ msg.datetimestamp }}</span>
    </div>


    </div>
</template>

<style lang="scss" scoped>
.rankings {
  background-color: rgba(5, 55, 10, 0.85);
  color: yellow !important;
  padding: 5px;
  padding-right: 15px;
  margin-left: 5px;
  margin-right: 5px;
  border: 1px solid rgba(160, 210, 120, 0.4);
  border-radius: 8px;
}
.game-summary-throw-bullseye {
  border: solid gray 1px;
  padding: 1px;
  display: inline; 
  float: left;
  color: red;
  margin-right: 2px;
  font-family: Consolas, "Liberation Mono", Menlo, Monaco, "Courier New", monospace;
}
.game-summary-throw {
  border: solid gray 1px;
  padding: 1px;
  display: inline; 
  float: left;
  margin-right: 2px;
  font-family: Consolas, "Liberation Mono", Menlo, Monaco, "Courier New", monospace;
}
.game-summary-round-total {
  padding: 10px;
  padding-left: 20px;
}

.match_box,
.rankings {
    position: relative;
    padding: 10px;
    margin-left: 5px;
    margin-right: 5px;
    background-color: rgba(5, 55, 10, 0.85);
    color: yellow;
    border-radius: 8px;
    border: 2px solid transparent;
    background-clip: padding-box;
}

.arcade-heading {
  font-family: 'Orbitron', sans-serif;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #f1e37d !important;
}

:deep(#app .arcade-heading) {
  color: #f1e37d !important;
}

.match_box::before,
.rankings::before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: inherit;
    padding: 2px;
    background: linear-gradient(135deg, rgba(240,220,120,0.9), rgba(30,120,40,0.9));
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: destination-out;
    mask-composite: exclude;
    pointer-events: none;
}
.scorecard_box {
    background-color: black; color: yellow; padding-left: 5px;
}

.mini-target-row {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 12px;
    margin-top: 6px;
    padding-top: 6px;
    border-top: 1px solid rgba(160, 210, 120, 0.2);
}
.mini-target-player {
    text-align: center;
}
.mini-target-label {
    font-size: 0.6em;
    margin-bottom: 2px;
    font-family: 'Orbitron', sans-serif;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}
.mini-target-container {
    position: relative;
    width: 120px;
    height: 114px;
    display: inline-block;
}
.mini-target-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    opacity: 0.7;
}
.mini-hit-marker {
    position: absolute;
    transform: translate(-50%, -50%);
    z-index: 1;
    font-size: 10px;
    text-shadow: 1px 1px 1px rgba(0,0,0,0.8);
    pointer-events: none;
}
</style>

<script>

export default {
  name: "DisplayItem",
  data () {
    return {
      publicPath: process.env.BASE_URL,
      // Reference: the 400x377 target image used in Match.vue for tournament/round robin
      REF_W: 400,
      REF_H: 377,
      BULL_X: 200,
      BULL_Y: 189
    }
  },
  components: {
  },
   props: {
     msg: {}
   },
  methods: {
    getPlayerColor(index) {
      var hue = (index * 137.508 + 180) % 360;
      return 'hsl(' + hue + ', 90%, 65%)';
    },
    getScoredThrows(matchPlayer) {
      return matchPlayer.throws.filter(t => t.scored && t.xPos > 0 && t.yPos > 0);
    },
    computeOffset(matchPlayers) {
      // Collect all scored bullseye throws to calibrate coordinate offset
      var bullseyes = [];
      matchPlayers.forEach(mp => {
        mp.throws.forEach(t => {
          if (t.scored && t.isBullsEye && t.xPos > 0) {
            bullseyes.push(t);
          }
        });
      });
      if (bullseyes.length > 0) {
        var avgX = bullseyes.reduce((s, t) => s + t.xPos, 0) / bullseyes.length;
        var avgY = bullseyes.reduce((s, t) => s + t.yPos, 0) / bullseyes.length;
        return { x: avgX - this.BULL_X, y: avgY - this.BULL_Y };
      }
      // Fallback: check if coords exceed image bounds
      var allThrows = [];
      matchPlayers.forEach(mp => {
        mp.throws.forEach(t => {
          if (t.scored && t.xPos > 0) allThrows.push(t);
        });
      });
      if (allThrows.length > 0 && allThrows.some(t => t.xPos > this.REF_W)) {
        var avgX = allThrows.reduce((s, t) => s + t.xPos, 0) / allThrows.length;
        var avgY = allThrows.reduce((s, t) => s + t.yPos, 0) / allThrows.length;
        return { x: avgX - this.BULL_X, y: avgY - this.BULL_Y };
      }
      return { x: 0, y: 0 };
    },
    getHitStyle(hit, playerIndex) {
      var offset = this.computeOffset(this.msg.control_value.match.matchPlayers);
      var xPct = ((hit.xPos - offset.x) / this.REF_W) * 100;
      var yPct = ((hit.yPos - offset.y) / this.REF_H) * 100;
      // Clamp to image bounds
      xPct = Math.max(0, Math.min(100, xPct));
      yPct = Math.max(0, Math.min(100, yPct));
      return {
        left: xPct + '%',
        top: yPct + '%',
        color: this.getPlayerColor(playerIndex)
      };
    }
  },
  mounted(){

  }
};
</script>
